<mat-card class="mt-2 journal-card">
  <mat-card-title-group>
    <mat-card-title class="h6">Journal</mat-card-title>
    <mat-card-subtitle>{{ load?.loadBay?.name ?? 'Load Bay Journals' }}</mat-card-subtitle>
  </mat-card-title-group>

  <mat-card-content>
    <div class="journal-table-container">
      <table mat-table [dataSource]="dataSource" class="journal-table">
        <ng-container matColumnDef="date">
          <th mat-header-cell *matHeaderCellDef>Date</th>
          <td mat-cell *matCellDef="let journal">{{ journal.date | date: 'medium' }}</td>
        </ng-container>

        <ng-container matColumnDef="change">
          <th mat-header-cell *matHeaderCellDef>Change</th>
          <td mat-cell *matCellDef="let journal">{{ journal.change }}</td>
        </ng-container>

        <ng-container matColumnDef="productSku">
          <th mat-header-cell *matHeaderCellDef>Product SKU</th>
          <td mat-cell *matCellDef="let journal">
            {{ journal.productSku?.sku ?? journal.productSku?.name ?? '' }}
          </td>
        </ng-container>

        <ng-container matColumnDef="container">
          <th mat-header-cell *matHeaderCellDef>Container</th>
          <td mat-cell *matCellDef="let journal">
            {{ journal.container?.name ?? journal.containerId ?? '' }}
          </td>
        </ng-container>

        <ng-container matColumnDef="responsibleUser">
          <th mat-header-cell *matHeaderCellDef>Responsible</th>
          <td mat-cell *matCellDef="let journal">{{ formatUser(journal) }}</td>
        </ng-container>

        <ng-container matColumnDef="history">
          <th mat-header-cell *matHeaderCellDef>History</th>
          <td mat-cell *matCellDef="let journal">
            <button
              mat-stroked-button
              color="primary"
              type="button"
              [disabled]="!journal.containerId"
              (click)="openHistory(journal)"
            >
              <i class="fa fa-history mr-1"></i>
              History
            </button>
          </td>
        </ng-container>

        <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
        <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>
        <tr class="mat-row" *matNoDataRow>
          <td class="mat-cell" [attr.colspan]="displayedColumns.length">No journals found</td>
        </tr>
      </table>
    </div>
  </mat-card-content>

  <mat-card-footer>
    <div class="journal-footer">
      <mat-paginator
        [length]="totalCount"
        [pageIndex]="pageIndex"
        [pageSize]="pageSize"
        [pageSizeOptions]="[5, 10, 20]"
        showFirstLastButtons
        (page)="onPageChange($event)"
      >
      </mat-paginator>
      <mat-progress-bar *ngIf="loading" mode="indeterminate"></mat-progress-bar>
    </div>
  </mat-card-footer>
</mat-card>
